export default function() {
  return new Worker(__webpack_public_path__ + "bundle.worker.js");
}
